import { render, staticRenderFns } from "./ui-switch.vue?vue&type=template&id=429f6217&scoped=true&"
import script from "./ui-switch.vue?vue&type=script&lang=js&"
export * from "./ui-switch.vue?vue&type=script&lang=js&"
import style0 from "./ui-switch.vue?vue&type=style&index=0&id=429f6217&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f6217",
  null
  
)

export default component.exports